import { Fragment, ReactNode } from "react";
import { formatList } from "src/utils";
import { PotentialOperation2 } from "../../generated/graphqlTypes";

export function disableBasedOnPotentialOperation(potentialOperation?: PotentialOperation2): boolean | ReactNode {
  if (canPerformOperation(potentialOperation)) {
    return false;
  }

  return (
    <Fragment>
      {potentialOperation!.disabledReasons.map((dr, i) => {
        const lines = dr.message
          .split("\n")
          // replace whitespace with a non-breaking unicode
          .map((line) => line.replace(/^\s/, "\u00A0"))
          // respect line breaks
          .flatMap((line, i) => (i === 0 ? line : [<br />, line]));

        return <div key={i}>{lines}</div>;
      })}
    </Fragment>
  );
}

export function disableBasedOnPotentialOperationText(potentialOperation?: PotentialOperation2): boolean | string {
  if (canPerformOperation(potentialOperation)) {
    return false;
  }

  return formatList(potentialOperation?.disabledReasons.map((r) => r.message) ?? []);
}

function canPerformOperation(potentialOperation?: PotentialOperation2): boolean {
  return !potentialOperation || potentialOperation.allowed;
}
